export default __webpack_public_path__ + "static/star_w.09999a6b25ff2efe30d0c47e04993547.svg";